import { render } from "./k-avatar-edit.vue?vue&type=template&id=6d47b220"
import script from "./k-avatar-edit.vue?vue&type=script&lang=js"
export * from "./k-avatar-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-user-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__